import { Resource } from '@/clients/utoniq-core/schema'

import { SoundDRMPlayer } from './SoundDRMPlayer'
import { SoundPurePlayer } from './SoundPurePlayer'

type Props = {
  resource: Resource
  /**
   * プレイヤーの自動再生の設定
   */
  autoplay?: boolean
}

export const SoundPlayer = ({ resource, autoplay }: Props) => {
  if (resource.drm?.encryptingStatus === 'encrypted') {
    return <SoundDRMPlayer resource={resource} autoplay={autoplay} />
  }

  return <SoundPurePlayer uri={resource.uri || ''} autoplay={autoplay} />
}
